import { AccountService } from '@/core/services/api-gateway'
import { BaseModule } from '@core/base/module/base-module'
import { loadTheme, constructTheme } from '@core/theme'
import { UserModule } from '../user/user.module'
import { CustomThemeInterface } from '@atbay/theming'

interface UISettingsState {
    theme: 'dark' | 'light'
}

const state = {
    theme: (UserModule.store.get().currentUser?.appearance
        ? UserModule.store.get().currentUser?.appearance
        : (localStorage.getItem('theme') ?? 'light')) as 'dark' | 'light',
} satisfies UISettingsState

class UI extends BaseModule<UISettingsState> {
    constructor(state: UISettingsState) {
        super(state, 'ui-settings.module')
    }

    async setTheme(
        themeVariant: UISettingsState['theme'],
        updateServer = false
    ) {
        this.store.setKey('theme', themeVariant)
        localStorage.setItem('theme', themeVariant)

        updateServer && AccountService.changeAppearance(themeVariant)
    }

    getThemeName() {
        const { theme } = this.useStore()
        return theme
    }

    getTheme() {
        const { theme: t } = this.useStore()
        const theme = loadTheme(t)
        constructTheme(theme as CustomThemeInterface)
        return theme
    }
}

export const UIModule = new UI(state)
